import React, {useEffect, useRef} from 'react';
import ControlButtonStandard, {
    ControlButtonType
} from "../../../../../core/gd-components/buttons/control-button/control-button-standard";
import {ControlButtonSize} from "../../../../../core/gd-components/buttons/control-button/@types";
import Input from "../../../../../core/gd-form-elements/input/input";
import {SpaceSearch} from "../../search/space-search";

type Props = {
    className?      : string
    spaceSearch     : SpaceSearch
}

export default function MenuTopHeader_SearchButton(props: Props) {

    const spaceSearch = props.spaceSearch


    const onClick = ()=>{
        spaceSearch.isActive = true
        spaceSearch.reRender()
    }

    return (
        <ControlButtonStandard className    = {props.className}
                               type         = {ControlButtonType.SEARCH}
                               size         = {ControlButtonSize.SIZE_28}
                               onClick      = {onClick}/>
    )
}
